import { ContextWrapper } from "@common/contexts";
import { ExamStore } from "@hospital/views/exam";

export const ExamStoreContentWrapper = new ContextWrapper<ExamStore>();
